<div [ngClass]="{'extra-height': !!verticalLeftContainerPatientView}"
     class="documents-tab Flexbox Flexbox__box-align-start Flexbox__align-self-start">

    <gen-documents-list *ngIf="!verticalLeftContainerPatientView"
                        class="documents-list"
                        [documents]="testRelatedDocuments"
                        (selectedDocument)="onSelectedDocument($event)"
    ></gen-documents-list>
    <gen-document-preview *ngIf='!testIsCompleted' id="print-section" class="documents-preview"
                          [ngClass]="{'wide-preview':verticalLeftContainerPatientView}"
                          [testData]="testData"
                          [selectedDocument]="currentDocument"
                          [editModeChangeSubject]="editModeChangeSubject"
                          [showEditDocumentsButton]="showEditDocumentsButton"
                          [editingIsPermitted] = "editingIsPermitted"
                          [enableFreeStyleEdit] = "enableFreeStyleEdit"
                          (toggleAction)="toggleActionFromChild($event)">
    </gen-document-preview>

    <div *ngIf='testIsCompleted' class="documents-pdf-viewer">
        <ng2-pdfjs-viewer #pdfViewer [openFile]="false" [download]="false" [viewBookmark]="false"
                          class="documents-pdfjs-viewer"></ng2-pdfjs-viewer>
    </div>

    <gen-documents-actions class="documents-actions"
                           [documents]="testRelatedDocuments"
                           (editingMode)="onEditingMode($event)"
                           [completed]="testIsCompleted"
                           (selectedAction)="onPrintDocument($event)"
                           (generateAction)="onGenerateDocument($event)"
                           [editingIsPermitted]="editingIsPermitted"
                           [showAddendumReportActions]="finalReportExists"
                           (releaseReport)="onReleaseReport($event)"
                           (generateAndDownloadReport)="onGenerateAndDownloadReport()"
                           [enableGenerateAndDownloadButton]="enableGenerateAndDownloadButton"
                           [generateAndDownloadButtonText]="generateAndDownloadButtonText"
                           [showReleaseDocumentsMenu]="showReleaseDocumentsMenu"
                           [showEditDocumentsButton]="showEditDocumentsButton"
                           [reportType]="reportTypeToRelease"
                           [showPrintButton]="showPrintButton"
                           [enableEditButton] = "enableEditButton"
                           [toggleAction]="toggleAction">
    </gen-documents-actions>

</div>

<div *ngIf="downloadInProgress">
    <gen-overlay-loader></gen-overlay-loader>
</div>
